{
  "languages": {
    "arabic": "العربية",
    "belarusian": "البيلاروسية",
    "chinese": "الصينية",
    "dutch": "الهولندية",
    "english": "الإنجليزية",
    "french": "الفرنسية",
    "german": "الألمانية",
    "italian": "الإيطالية",
    "japanese": "اليابانية",
    "korean": "الكورية",
    "lithuanian": "الليتوانية",
    "portuguese": "البرتغالية",
    "romanian": "الرومانية",
    "spanish": "الإسبانية",
    "turkish": "التركية"
  }
}
